import {ICell, template as tpl, viewModel as SearchViewModel} from "../search/search";
import {IExportTemplate, IRouteDefinitionParams, ITableColumn} from "../../index";
import {global} from "../../appContext";
import pubsub from "../../pubsub";
import {nsClone} from "../../clone/fn";
import {getObjectDefinition, isSupportedCircle} from "../../util/misc";
import {getHash, getRouteDefinition, getRouteDropdownButton} from "../../constants/RouteDefinitions";
import {ISearchRowButtons} from "../search/index";
import {nsSynchronizationTemplateClone} from "../../clone/nsSynchronizationTemplateClone";
import * as ko from "knockout";
import {ISplitButtonParams} from "@component/button/splitButton/split-button";
import {UPDATING_MESSAGE} from "../../constants/Language";
import PromiseRequest from "../../req/PromiseRequest";
import {_} from 'lodash';
import {nsSync} from "../../util/nsSync";

export let template: string = tpl;

export class viewModel extends SearchViewModel {
    private readonly togglingTemplateIds: KnockoutObservableArray<number> = ko.observableArray<number>([]);
    private requests: PromiseRequest[] = []

    public TABLE: Array<ITableColumn> = [
        {
            key: "Id",
        },
        {
            key: "Name",
            css: 'wordBreak--all',
        },
        {
            key: "objecttype",
            label: "object type"
        },
        {
            key: "ruleset.name",
            css: 'wordBreak--all',
            label: "ruleset",
        },
        {
            key: "syncstep.syncstep.name",
            label: "synchronization step"
        },
        {
            key: "exportflow",
            count: true,
            label: "number of subjects|s:((attribute|p|ac))",
        },
        {
            key: 'active',
            center: true,
        },
        {
            key: "func",
            label: "",
            validator: () => global.permissionValidator.isMinCompanyAdmin(),
        }
    ];

    protected override fnRow: KnockoutObservableArray<ISearchRowButtons> = ko.observableArray<ISearchRowButtons>([]);

    constructor(params: IRouteDefinitionParams) {
        super(params);

        this.populateButtons();

        pubsub.on(this, "exporttemplate.copy.success", this.searchChangedHandler.bind(this));
        pubsub.on(this, "exporttemplate.delete.success", () => this.preSubmit(true, true, 0));
    }

    private populateButtons() {
        this.fnRow.removeAll();

        if (global.permissionValidator.isMinCompanyAdmin()) {
            const defEdit = getRouteDefinition('editsynctemplate');
            if (!defEdit) {
                return;
            }
            this.fnRow([
                {
                    icon: 'fa-ellipsis-v',
                    getComponent: (exportTemplate: IExportTemplate) => {
                        return {
                            name: 'component/button/ellipsis-dropdown',
                            params: {
                                buttons: [
                                    {
                                        label: defEdit.label,
                                        href: () => getHash('editsynctemplate', {id: exportTemplate.id}),
                                    },
                                    {
                                        label: 'copy',
                                        onClick: () => nsSynchronizationTemplateClone.copyDialog(exportTemplate)
                                    },
                                    {
                                        label: exportTemplate.active ? 'deactivate' : 'activate',
                                        onClick: () => this.onToggleActiveClick(exportTemplate),
                                        enabled: () => !this.isToggling(exportTemplate.id),
                                    },
                                    {
                                        label: 'delete',
                                        onClick: () => nsSynchronizationTemplateClone.trashDialog(exportTemplate)
                                    }
                                ],
                            },
                        }
                    }
                },
            ]);
        }

    }

    private isToggling(id: number): boolean {
        return this.togglingTemplateIds.indexOf(id) > -1;
    }

    private finishToggle(id: number) {
        this.togglingTemplateIds.remove(id);
    }

    private updateActiveInRow(id: number, active: boolean) {
        const updated = this.dataArray().map((item: IExportTemplate) =>
            item.id === id
                ? {...item, active}
                : item
        );
        this.dataArray(updated);
    }

    private onToggleActiveClick(exportTemplate: IExportTemplate) {
        if (this.isToggling(exportTemplate.id)) {
            return;
        }

        const id = exportTemplate.id;
        const active = !exportTemplate.active;
        this.togglingTemplateIds.push(id);
        this._searchMessage({message: UPDATING_MESSAGE});

        const req_updateexporttemplate = new PromiseRequest('updateexporttemplate')
        this.requests.push(req_updateexporttemplate)

        const d = _.cloneDeep(exportTemplate);
        d.active = active;
        d.exportflow = [];
        return req_updateexporttemplate.request({jexporttemplate: JSON.stringify(d)})
            .then(() => {
                this.requests = this.requests.filter(r => r !== req_updateexporttemplate);

                global.cacheManager.removeCache('searchexporttemplate');
                global.cacheManager.removeCache('getexporttemplate');

                this._searchMessage(null as any);
                this.updateActiveInRow(id, active);
                this.finishToggle(id);
            })
            .catch((reason: string) => {
                this.requests = this.requests.filter(r => r !== req_updateexporttemplate);

                this._searchMessage({
                    message: String(reason),
                    type: 'danger',
                });
                this.finishToggle(id);
            });
    }

    private searchChangedHandler() {
        const selectedOrganization = global.login.selectedOrganization();
        const targetOrg = nsClone.targetOrg();
        if (selectedOrganization && targetOrg && selectedOrganization.organizationid === targetOrg.organizationid) {
            this.preSubmit(true, true, 0);
        }
    }

    protected override getCellContent(obj: ICell): string | number {
        const def = this.TABLE.find((t: ITableColumn) => t.key == obj.key);
        let val = this.getCellVal(obj)
        if (String(obj.key).includes(".")) {
            try {
                val = String(obj.key).split('.').reduce((o: any, key: string) => o[key], obj.item);
            } catch (err) {
            }
        }

        if (def?.count) {
            return val.length;
        }

        switch (obj.key) {
            case 'active':
                return isSupportedCircle(val)
        }

        return super.getCellContent({val}, obj);
    }

    protected override getCellText(obj: ICell): string {
        const val = this.getCellVal(obj)
        switch (obj.key) {
            case 'active':
                return val ? 'Ja' : 'Nei';
            case 'objecttype':
                return getObjectDefinition(val)?.singular ?? '';
            case 'syncstep.syncstep.name': {
                const syncstep = (obj.item as IExportTemplate).syncstep?.syncstep;
                return syncstep ? nsSync.getSyncstepName(syncstep) : (val ?? '');
            }
        }
        return super.getCellText(obj);
    }

    protected override getSearchSplitButtonParams(): ISplitButtonParams {
        return {
            mainButton: getRouteDropdownButton('createsynctemplate', { cls: 'btn-action btn-sm', icon: 'fa-plus' }),
        }
    }

    override dispose() {
        super.dispose();
        this.requests.forEach(r => r.abort())
    }
}
